import type { VoidFunctionComponent } from 'react';
import AddGitHubAppButton from './gitHubApp/AddGitHubAppButton';
import GitHubAppInstallationsTable from './gitHubApp/GitHubAppInstallationsTable';
import styles from './GitHubAppSettings.module.less';

const GitHubAppSettingsPage: VoidFunctionComponent = () => {
  return (
    <>
      <div className="text-center margin-bottom-sm">
        <h1>GitHub App Installations</h1>
        <p>
          FOSSA GitHub App allows users and organizations to easily
          import and analyze projects that live in GitHub.
        </p>
      </div>
      <hr />
      <h3 className={styles.tableHeader}>
        Installation List
        <AddGitHubAppButton />
      </h3>
      <GitHubAppInstallationsTable />
    </>
  );
};

export default GitHubAppSettingsPage;
